import { BaseElement, defineElement } from '@webtides/element-js';
import { urlQueryFromParameters } from '/webresources-sources/js/util/url';

// TODO: remove jquery from here...

/**
 * @property {array} selectedCategories
 * @property {object} filteredCategories
 * @property {string} url
 * @property {string} contentPath
 * @property {number} currentPage
 * @property {number} previousPageIndex
 * @property {number} seed
 * @property {string} filterName
 * @property {string} seedUrlParameterName
 * @property {string} pageUrlParameterName
 */
export default class PageTeasersComponent extends BaseElement {
    properties() {
        return {
            selectedCategories: [],
            filteredCategories: {},
            url: '',
            contentPath: '',
            currentPage: 0,
            previousPageIndex: -1,
            seed: 0,
            filterName: 'foo',
            seedUrlParameterName: 'seed',
            pageUrlParameterName: 'currentPage',
        };
    }

    connected() {
        this.previousPageIndex = this.currentPage - 1;
        this.updateUrl();
    }

    afterUpdate() {
        /** @type PageCount */
        const pageCount = this.querySelector('page-count');
        if (pageCount) {
            pageCount.currentPage = this.currentPage;
            pageCount.previousPageIndex = this.previousPageIndex;
        }

        this.updateUrl();
    }

    watch() {
        return {
            selectedCategories: (selectedCategories) => {
                //console.log('selectedCategories',selectedCategories);
                const clearFilterButton = this.querySelector('[data-clear-filter=""]');

                if (!clearFilterButton) return;

                if (selectedCategories && selectedCategories.length > 0) {
                    clearFilterButton.classList.remove('d-none');
                } else {
                    clearFilterButton.classList.add('d-none');
                }
            },
        };
    }

    events() {
        return {
            this: {
                'init-categories': (e) => {
                    // console.log('init-categories', e.detail);
                    this.selectedCategories = e.detail.selectedCategories;
                    this.filteredCategories = e.detail.filteredCategories;
                },
                'select-categories': (e) => {
                    // console.log('select-categories', e.detail);
                    this.selectedCategories = e.detail.selectedCategories;
                    this.filteredCategories = e.detail.filteredCategories;
                    this.currentPage = 0;
                    // this.seed = new Date().getTime();

                    this.dispatch('loading-start');
                    this.fetchPages().then((html) => {
                        this.dispatch('loading-end');
                        const container = this.querySelector('.pages');
                        $(container).html($(html).find('.page-count,.previous-page,.page,.next-page'));
                        this.registerEvents();
                    });
                },
            },
            '[load-previous-page]': {
                click: (e) => {
                    e.preventDefault();
                    const previousPageIndex = parseInt(e.target.getAttribute('load-previous-page'));

                    this.fetchPages(previousPageIndex).then((html) => {
                        this.previousPageIndex--;
                        const container = this.querySelector('.previous-page');
                        $(container).replaceWith($(html).find('.previous-page,.page'));
                        this.registerEvents();
                    });
                },
            },
            '[load-next-page]': {
                click: (e) => {
                    e.preventDefault();
                    this.currentPage = parseInt(e.target.getAttribute('load-next-page'));

                    this.fetchPages(this.currentPage).then((html) => {
                        const container = this.querySelector('.next-page');
                        $(container).replaceWith($(html).find('.page,.next-page'));
                        this.registerEvents();
                    });
                },
            },
            '[data-page]': {
                click: (e) => {
                    const pageContainer = e.target.closest('[data-page]');
                    if (e.target.nodeName === 'A' && pageContainer) {
                        this.currentPage = parseInt(pageContainer.dataset.page);
                    }
                },
            },
        };
    }

    getUrlParameters(currentPage = this.currentPage) {
        // TODO: use composable for this kind of url parameter building
        const filters = Object.entries(this.filteredCategories)
            .filter(([category, childCategories]) => childCategories.length > 0)
            .map(([category, childCategories]) => {
                return `${category}=${childCategories.join(',')}`;
            });

        if (currentPage > 0) {
            filters.push(`${this.pageUrlParameterName}=${this.currentPage}`);
        }

        if (this.seed !== 0) {
            filters.push(`${this.seedUrlParameterName}=${this.seed}`);
        }

        return {
            [this.filterName]: filters.length > 0 ? filters.join('&') : undefined,
        };
    }

    fetchPages(currentPage = this.currentPage) {
        const urlParameters = this.getUrlParameters(currentPage);
        return fetch(`${this.contentPath}?${urlQueryFromParameters(urlParameters)}`).then((result) => result.text());
    }

    updateUrl() {
        const urlParameters = this.getUrlParameters();
        const query = urlQueryFromParameters(urlParameters, true);
        history.replaceState(urlParameters, '', query ? `?${query}` : location.pathname);
    }
}

defineElement('page-teasers-component', PageTeasersComponent);
